export enum ActivityType {
  SocInternalMessage = 4000,
  SocAssign = 4001,
  SocUnassign = 4002,
  SocCaseNote = 4003,
  SocClose = 4004,
  SocReopen = 4005,
  SocMessageSentOfqual = 4006,
  SocMessageSentAO = 4007,
  SocEventAdded = 4008,
  SocEventCompleted = 4009,
  SocSent = 4010,
}

export const OfqualOnlyActivityTypes = [
  ActivityType.SocInternalMessage,
  ActivityType.SocAssign,
  ActivityType.SocUnassign,
  ActivityType.SocCaseNote,
  ActivityType.SocEventAdded,
  ActivityType.SocEventCompleted
]